import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
// import Dropdown from "../../../components/AdminDropdown/Dropdown";

function Companies() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    
    {
      header: "Phone",
      accessorKey: "Phone",
    },
    {
      header: "Address",
      accessorKey: "Address",
    },
    {
      header: "Description",
      accessorKey: "Description",
    },
    {
      header: "Actions",
      accessorKey: "total",
      // cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([
   {
    SN: 1,
    Name: "Methologik",
    Email: "info@methologik.com",
    Phone: "03441312900",
    Address: "test address",
    Description: "test"
   }
  ]);
  const [buttonData] = useState([
    {
      buttonText: "Add Company ",
      path: "addCompanyForm"
    },
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        buttonData={buttonData}
      

      />
    </main>
  );
}

export default Companies;
